import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingAIChat from './components/FloatingAIChat';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import HowItWorks from './pages/HowItWorks';
import CoveragePricing from './pages/CoveragePricing';
import Impact from './pages/Impact';
import Providerships from './pages/Providerships';
import ForSchools from './pages/ForSchools';
import ForClinics from './pages/ForClinics';
import ForNGOs from './pages/ForNGOs';
import CSRInvestors from './pages/CSRInvestors';
import Investors from './pages/Investors';
import Enroll from './pages/Enroll';
import FAQ from './pages/FAQ';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import ContactForm from './pages/ContactForm';
import ScheduleCall from './pages/ScheduleCall';
import PrivacyTerms from './pages/PrivacyTerms';
import Careers from './pages/Careers';
import StudentEnrollment from './pages/StudentEnrollment';
import SchoolEnrollment from './pages/SchoolEnrollment';
import CustomSchoolEnrollment from './pages/CustomSchoolEnrollment';
import EnrollmentSuccess from './pages/EnrollmentSuccess';
import Schools from './pages/Schools';
import SmartGames from './pages/SmartGames';
import SpaceCollect from './pages/SpaceCollect';
import UrgentCare from './pages/UrgentCare';

// Wrapper component to conditionally render footer
const AppContent = () => {
  const location = useLocation();
  const hideFooter = location.pathname === '/schools';

  // Scroll to top on route change with smooth animation
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  return (
    <div className="App min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex-1"
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/smart-games" element={<SmartGames />} />
          <Route path="/smart-games/space-collect" element={<SpaceCollect />} />
          <Route path="/schools" element={<Schools />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/coverage-pricing" element={<CoveragePricing />} />
          <Route path="/urgent-care" element={<UrgentCare />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/providerships" element={<Providerships />} />
          <Route path="/for-schools" element={<ForSchools />} />
          <Route path="/for-clinics" element={<ForClinics />} />
          <Route path="/for-ngos" element={<ForNGOs />} />
          <Route path="/csr-investors" element={<CSRInvestors />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/enroll" element={<Enroll />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/schedule-call" element={<ScheduleCall />} />
          <Route path="/privacy-terms" element={<PrivacyTerms />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/student-enrollment" element={<StudentEnrollment />} />
          <Route path="/school-enrollment" element={<SchoolEnrollment />} />
          <Route path="/enroll/:schoolName" element={<CustomSchoolEnrollment />} />
          <Route path="/enrollment-success" element={<EnrollmentSuccess />} />
        </Routes>
      </motion.main>
      {!hideFooter && <Footer />}

      {/* Floating AI Chat */}
      <FloatingAIChat context={{ type: 'general' }} />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
